import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import SignUpPage from './SignUpPage';
import type { AuthPageProps } from '../../types';
import { getEntryCode } from '../../lib/signupEntry';
import { PAID_SIGNUP_PATH } from '../../lib/authErrors';

const AuthPage: React.FC<AuthPageProps> = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Mostrar el formulario de registro si la ruta es exactamente /register
  const isSignup = location.pathname === '/register';

  const switchToLogin = (): void => {
    navigate('/login', { replace: true });
  };

  const switchToSignUp = (): void => {
    navigate('/register', { replace: true });
  };

  if (isSignup) {
    // Campaign links (/register?ref=<code>&plan=N) sign up through the paid flow.
    if (getEntryCode()) {
      return <Navigate to={`${PAID_SIGNUP_PATH}${location.search}`} replace />;
    }
    return <SignUpPage onSwitchToLogin={switchToLogin} />;
  }

  return <LoginPage onSwitchToSignUp={switchToSignUp} />;
};

export default AuthPage;